import { createFormContext } from "@mantine/form";
import { Asserts } from "yup";
import ideiaSchema from "../../schema/ideia-schema";

type FormInputs = Asserts<typeof ideiaSchema>;

const [IdeiaFormProvider, useIdeiaFormContext, useIdeiaForm] = createFormContext<FormInputs>();

export { IdeiaFormProvider, useIdeiaFormContext, useIdeiaForm };
